import { createAction, props } from '@ngrx/store';
import { RoleType } from '@wdx/clmi/clmi-swagger-gen';

export const searchRoles = createAction(
    '[Admin Roles] Search Admin Roles',
    props<{
        reset?: boolean;
        filter: any;
    }>(),
);

export const searchRolesSuccess = createAction(
    '[Admin Roles] Search Admin Roles Success',
    props<{
        roles: RoleType[];
    }>(),
);

export const searchRolesFailure = createAction(
    '[Admin Roles] Search Admin Roles Failure',
    props<{ error: Error }>(),
);
